if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();






this.addEventListener('click', (event) => {
  const previous = event.target.closest('.howe-gallery-prev');
  const next = event.target.closest('.howe-gallery-next');

  if (!previous && !next) return;


event.preventDefault();
event.stopPropagation();


  const images = Array.from(
    this.querySelectorAll(
      '.product-media-modal__content > [data-media-id]'
    )
  );

  if (images.length < 2) return;

  const current = images.findIndex(
    (image) => image.classList.contains('active')
  );

  if (current === -1) return;

  const direction = next ? 1 : -1;
  const newIndex =
    (current + direction + images.length) % images.length;

  images[current].classList.remove('active');
  images[newIndex].classList.add('active');
});

      }

      hide() {
        super.hide();
      }

      show(opener) {
  super.show(opener);
  this.showActiveMedia();

  this.querySelectorAll('.howe-gallery-navigation button')
    .forEach((button) => {
      if (button.dataset.howeReady) return;
      button.dataset.howeReady = 'true';

      button.addEventListener('pointerup', (event) => {
        event.stopPropagation();
      });
    });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
